/**
 * Arabic translations, keyed by the French source phrase.
 * GENERATED by scripts/i18n-build.cjs from scripts/i18n/*.json — edit those.
 */
export const AR: Record<string, string> = {
  " · CIN vérifiée": " · بطاقة التعريف موثّقة",
  " · non-fumeur": " · غير مدخن",
  " · pas de prix": " · بدون سعر",
  "— coordonnées, prix, logo, lien, nom de réseau social. Une annonce dont une vidéo en contient sera": "— معلومات الاتصال أو الأسعار أو الشعارات أو الروابط أو أسماء حسابات التواصل الاجتماعي. أي إعلان يحتوي فيديو فيه شيء من ذلك سيتم",
  ", s’il correspond à un compte.": "، إذا كان مرتبطًا بحساب.",
  ". Bedly ne voit jamais ces images.": ". لا يطّلع Bedly أبدًا على هذه الصور.",
  ". En production, aucun code n’est jamais renvoyé par l’API.": ". في بيئة الإنتاج، لا تُرجع الواجهة البرمجية أي رمز أبدًا.",
  ". Les positions affichées sont approximatives à 300 m près.": ". المواقع المعروضة تقريبية في حدود 300 متر.",
  ". Pensez à regarder dans les spams.": ". لا تنسَ التحقق من مجلد الرسائل غير المرغوب فيها.",
  ". Tant qu’il n’est pas saisi, vous ne pouvez ni réserver ni publier.": ". إلى أن تُدخله، لا يمكنك الحجز ولا النشر.",
  "· chaque cercle couvre environ 300 m autour du logement — l’adresse exacte n’est communiquée qu’après réservation.": "· تغطي كل دائرة نحو 300 متر حول السكن — ولا يُكشف العنوان الدقيق إلا بعد الحجز.",
  "· cible": "· الهدف",
  "· créé le": "· أُنشئ في",
  "· hôte": "· مضيف",
  "· KYC": "· التحقق من الهوية",
  "· payés en ligne, une seule fois": "· تُدفع عبر الإنترنت مرة واحدة",
  "· recadrée": "· مقصوصة",
  "· RIB ••••": "· الحساب البنكي ••••",
  "· une seule fois, à la réservation": "· مرة واحدة عند الحجز",
  "« {title} » — {neighborhood}, {city}": "«{title}» — {neighborhood}، {city}",
  "(avant le {date})": "(قبل {date})",
  "(exclu)": "(غير مشمول)",
  "). Le loyer de": "). إيجار",
  "). Vous la voyez parce que vous en êtes l’hôte ou un administrateur.": "). تراه لأنك مضيفه أو مسؤول.",
  "{count} annonce(s)": "{count} إعلان",
  "{count} annonce(s) en ligne": "{count} إعلان منشور",
  "{count} annonces en ligne": "{count} إعلانًا منشورًا",
  "{count} confirmées": "{count} مؤكدة",
  "{count} étoile(s)": "{count} نجمة",
  "{count} filtre(s)": "{count} فلتر",
  "{count} j": "{count} ي",
  "{count} logement(s)": "{count} سكن",
  "{count} logements": "{count} مساكن",
  "{count} mois": "{count} شهر",
  "{count} non lus": "{count} غير مقروءة",
  "{count} nuit(s)": "{count} ليلة",
  "{count} nuit(s) bloquée(s), {taken} déjà prise(s).": "تم إغلاق {count} ليلة، و{taken} محجوزة مسبقًا.",
  "{count} nuit(s) bloquée(s).": "تم إغلاق {count} ليلة.",
  "{count} nuit(s) libérée(s).": "تم تحرير {count} ليلة.",
  "{count} personne(s)": "{count} شخص",
  "{count} vérifiés": "{count} موثّق",
  "{count}/24 chiffres": "{count}/24 رقمًا",
  "{kind} à {where} · à partir de {price}{unit}.": "{kind} في {where} · ابتداءً من {price}{unit}.",
  "{kind} à {where}.": "{kind} في {where}.",
  "{max} photos — le maximum": "{max} صور — الحد الأقصى",
  "{max} photos maximum : les {count} dernières n’ont pas été ajoutées.": "{max} صور كحد أقصى: لم تتم إضافة آخر {count}.",
  "{max} vidéos — le maximum": "{max} فيديوهات — الحد الأقصى",
  "{minutes} min à pied du campus": "{minutes} دقيقة مشيًا من الحرم الجامعي",
  "{name} a envoyé une pièce d’identité.": "أرسل {name} وثيقة هوية.",
  "{name} souhaite réserver {title}.": "يرغب {name} في حجز {title}.",
  "{percent} % des visiteurs demandent": "{percent}% من الزوار يرسلون طلبًا",
  "{what} à {city}": "{what} في {city}",
  "{what} à {city} : annonces visitées par Bedly, hôtes vérifiés, prix tout compris. Vous ne payez en ligne que les frais Bedly, le loyer se règle en main propre.": "{what} في {city}: إعلانات زارتها Bedly، مضيفون موثّقون، أسعار شاملة. تدفع رسوم Bedly فقط عبر الإنترنت، ويُدفع الإيجار يدًا بيد.",
  "{what} au Maroc": "{what} في المغرب",
  "@bedly.ma": "@bedly.ma",
  "/mois": "/شهر",
  "/nuit": "/ليلة",
  "← Mes réservations": "→ حجوزاتي",
  "← Quitter": "→ خروج",
  "← Retour à l’annonce": "→ العودة إلى الإعلان",
  "← Retour aux résultats": "→ العودة إلى النتائج",
  "← Tableau de bord": "→ لوحة التحكم",
  "+ Ajouter des photos ({count}/{max})": "+ إضافة صور ({count}/{max})",
  "+ Ajouter une chambre": "+ إضافة غرفة",
  "+ Ajouter une photo": "+ إضافة صورة",
  "+ Ajouter une vidéo ({count}/{max})": "+ إضافة فيديو ({count}/{max})",
  "+ Nouvelle annonce": "+ إعلان جديد",
  "+ Publier ma demande": "+ نشر طلبي",
  "+ Publier une nouvelle demande": "+ نشر طلب جديد",
  "×": "×",
  "★ Couverture": "★ صورة الغلاف",
  "♡ Enregistrer": "♡ حفظ",
  "♥ Enregistrée": "♥ محفوظ",
  "1 an": "سنة",
  "10 mois (année universitaire)": "10 أشهر (سنة دراسية)",
  "12 % par séjour confirmé pour les nuitées": "12٪ عن كل إقامة مؤكدة في الإيجار بالليلة",
  "12, rue Jbel Bouiblane": "12، زنقة جبل بويبلان",
  "30 derniers jours": "آخر 30 يومًا",
  "6 caractères minimum.": "6 أحرف على الأقل.",
  "8 % du premier mois pour une location au mois ou en colocation": "8٪ من الشهر الأول للإيجار الشهري أو السكن المشترك",
  "8 caractères minimum, avec des lettres et des chiffres.": "8 أحرف على الأقل، تتضمن حروفًا وأرقامًا.",
  "8 caractères minimum, lettres et chiffres.": "8 أحرف على الأقل، حروف وأرقام.",
  "à encaisser en espèces": "يُستلم نقدًا",
  "à l'instant": "الآن",
  "À la nuit": "بالليلة",
  "À la remise des clés, directement à vous": "عند تسليم المفاتيح، مباشرة إليك",
  "À payer maintenant en ligne": "يُدفع الآن عبر الإنترنت",
  "À propos du logement": "حول السكن",
  "À remettre en espèces à l’hôte": "يُسلَّم نقدًا للمضيف",
  "À répondre avant le": "الرد قبل",
  "À traiter": "بحاجة إلى معالجة",
  "À valider": "بانتظار المراجعة",
  "À venir": "قادمة",
  "Acceptée — dépôt à régler": "مقبول — الرسوم في انتظار الدفع",
  "Acceptée — frais de service à régler": "مقبول — رسوم الخدمة مستحقة الدفع",
  "Accepter": "قبول",
  "Acompte de 500 DH en ligne, le reste au check-in": "عربون 500 درهم عبر الإنترنت، والباقي عند الوصول",
  "Actif": "نشط",
  "Activation…": "جارٍ التفعيل…",
  "Active": "نشط",
  "Activées sur cet appareil : demandes, réservations et messages arrivent même quand Bedly est fermé.": "مفعّلة على هذا الجهاز: تصلك الطلبات والحجوزات والرسائل حتى عندما يكون Bedly مغلقًا.",
  "Activer les notifications": "تفعيل الإشعارات",
  "Activez au moins un mode de location avec un prix.": "فعّل نوع إيجار واحدًا على الأقل مع سعره.",
  "Activez au moins un type de location avec un prix.": "فعّل نوع كراء واحدًا على الأقل مع سعر.",
  "Admin": "الإدارة",
  "Adresse": "العنوان",
  "Adresse :": "العنوان:",
  "Adresse exacte": "العنوان الدقيق",
  "Adresse exacte :": "العنوان الدقيق:",
  "Adresse introuvable — voici le centre de la ville": "العنوان غير موجود — هذا مركز المدينة",
  "Adresse introuvable. Placez le point à la main.": "العنوان غير موجود. ضع العلامة يدويًا.",
  "Adresse précise": "عنوان دقيق",
  "Afficher le mot de passe": "إظهار كلمة المرور",
  "Afficher plus": "عرض المزيد",
  "Affilié créé — code {code}": "تم إنشاء الشريك — الرمز {code}",
  "Affilié mis en pause": "تم إيقاف الشريك مؤقتًا",
  "Affilié réactivé": "تمت إعادة تفعيل الشريك",
  "Affiliés": "الشركاء",
  "Agadir": "أكادير",
  "Agdal": "أكدال",
  "Agdal, Hassan…": "أكدال، حسان…",
  "Agdal, studio, proche tram…": "أكدال، استوديو، قرب الترامواي…",
  "Ajouter": "إضافة",
  "Ajoutez au moins {count} photos.": "أضف {count} صور على الأقل.",
  "Ajoutez des photos": "أضف صورًا",
  "Ajoutez une chambre pour la louer indépendamment. Réserver le logement entier bloque automatiquement toutes les chambres, et inversement.": "أضف غرفة لتأجيرها بشكل مستقل. حجز السكن بالكامل يحجز جميع الغرف تلقائيًا، والعكس صحيح.",
  "Al Akhawayn University": "جامعة الأخوين",
  "Alerte activée": "تم تفعيل التنبيه",
  "Annonce à corriger": "الإعلان يحتاج إلى تعديل",
  "Annonce à valider": "إعلان بانتظار الموافقة",
  "Annonce approuvée et mise en ligne.": "تمت الموافقة على الإعلان ونشره.",
  "Annonce en ligne": "الإعلان منشور",
  "Annonce enregistrée.": "تم حفظ الإعلان.",
  "Annonce envoyée !": "تم إرسال الإعلان!",
  "Annonce envoyée pour vérification.": "تم إرسال الإعلان للمراجعة.",
  "Annonce introuvable": "الإعلان غير موجود",
  "Annonce mise à jour.": "تم تحديث الإعلان.",
  "Annonce mise en pause.": "تم إيقاف الإعلان مؤقتًا.",
  "Annonce renvoyée en brouillon.": "أُعيد الإعلان إلى المسودة.",
  "Annonce supprimée.": "تم حذف الإعلان.",
  "Annonces": "الإعلانات",
  "Annonces à {city} visitées par Bedly, hôtes vérifiés, prix tout compris.": "إعلانات في {city} زارتها Bedly، مضيفون موثّقون، أسعار شاملة.",
  "Annonces à vérifier": "إعلانات بانتظار المراجعة",
  "Annonces de colocation publiées par des étudiants : chambre libre, budget, quartier et campus. Répondez directement, sans intermédiaire et sans frais de dossier.": "طلبات سكن مشترك ينشرها الطلاب: غرفة شاغرة، الميزانية، الحي والحرم الجامعي. رُدّ مباشرة، بدون وسيط وبدون رسوم ملف.",
  "annonces en attente": "إعلانات في الانتظار",
  "Annonces en ligne": "الإعلانات المنشورة",
  "Annonces en ligne par ville": "الإعلانات المنشورة حسب المدينة",
  "Annonces publiées": "الإعلانات المنشورة",
  "Annonces récentes": "أحدث الإعلانات",
  "Annulation par l’hôte ou Bedly": "إلغاء من المضيف أو Bedly",
  "Annulée": "ملغى",
  "Annuler": "إلغاء",
  "Annuler la réservation": "إلغاء الحجز",
  "Aperçu": "معاينة",
  "Aperçu de votre annonce": "معاينة إعلانك",
  "Aperçu public": "المعاينة العامة",
  "Apparence": "المظهر",
  "Appartement ou maison rien que pour le locataire": "شقة أو منزل للمستأجر وحده",
  "approuvée": "مقبولة",
  "Approuver": "قبول",
  "Arrivée": "الوصول",
  "Ascenseur": "مصعد",
  "Attijariwafa Bank": "التجاري وفا بنك",
  "Au moins {n} caractères.": "{n} أحرف على الأقل.",
  "Au moins {n} éléments.": "{n} عناصر على الأقل.",
  "Au moins 8 caractères.": "8 أحرف على الأقل.",
  "Au mois": "بالشهر",
  "Au plus {n} caractères.": "{n} حرفًا كحد أقصى.",
  "Au plus {n} éléments.": "{n} عناصر كحد أقصى.",
  "Aucun affilié pour l’instant": "لا يوجد شركاء بعد",
  "Aucun appareil n’a reçu la notification.": "لم يستلم أي جهاز الإشعار.",
  "Aucun avis publié pour le moment.": "لم تُنشر أي تقييمات بعد.",
  "Aucun code en attente pour cette adresse. Demandez-en un nouveau.": "لا يوجد رمز في الانتظار لهذا العنوان. اطلب رمزًا جديدًا.",
  "Aucun frais n’a encore été encaissé : rien à rembourser.": "لم يتم تحصيل أي رسوم بعد: لا شيء لاسترداده.",
  "aucun numéro de téléphone ni aucun texte": "أي رقم هاتف أو أي نص",
  "Aucun prix défini": "لم يُحدد سعر",
  "Aucun résultat": "لا توجد نتائج",
  "Aucun résultat.": "لا توجد نتائج.",
  "Aucun signalement ouvert": "لا توجد بلاغات مفتوحة",
  "Aucune annonce": "لا توجد إعلانات",
  "Aucune annonce en attente": "لا توجد إعلانات قيد الانتظار",
  "Aucune annonce en ligne pour le moment": "لا توجد إعلانات منشورة حاليًا",
  "Aucune annonce enregistrée": "لا توجد إعلانات محفوظة",
  "Aucune chambre séparée. Ajoutez-en une pour la louer indépendamment du logement entier.": "لا توجد غرف منفصلة. أضف غرفة لتأجيرها بشكل مستقل عن السكن بالكامل.",
  "Aucune conversation": "لا توجد محادثات",
  "Aucune demande": "لا توجد طلبات",
  "Aucune demande de colocation": "لا توجد طلبات سكن مشترك",
  "Aucune demande en attente : tout est à jour.": "لا توجد طلبات في الانتظار: كل شيء محدَّث.",
  "Aucune demande trouvée": "لم يتم العثور على طلبات",
  "Aucune identité en attente": "لا توجد هويات بانتظار التحقق",
  "Aucune image de document n’est stockée par Bedly. Ouvrez le dossier chez le prestataire avec la référence ci-dessous.": "لا يخزّن Bedly أي صور للوثائق. افتح الملف لدى مزوّد الخدمة باستخدام المرجع أدناه.",
  "Aucune notification": "لا توجد إشعارات",
  "Aucune photo": "لا توجد صورة",
  "Aucune réservation": "لا توجد حجوزات",
  "Aucune université": "بدون جامعة",
  "Auteurs et licences des photos des villes sur Bedly.": "مؤلفو صور المدن على Bedly وتراخيصها.",
  "Autres photos": "صور أخرى",
  "Avant de publier :": "قبل النشر:",
  "Avis": "التقييمات",
  "Avis reçus": "التقييمات المستلمة",
  "Badge « Visité » après le passage de notre équipe, sous 48 h": "شارة «تمت زيارته» بعد مرور فريقنا، خلال 48 ساعة",
  "Balcon": "شرفة",
  "Banque (optionnel)": "البنك (اختياري)",
  "Bedly": "Bedly",
  "Bedly n’encaisse que ses frais de service (": "لا يحصّل Bedly سوى رسوم الخدمة (",
  "Bedly ne perçoit que ses frais de service : le loyer est réglé directement à l’hôte, en espèces, lorsque vous vous rencontrez. Annulation :": "لا يتقاضى Bedly سوى رسوم الخدمة: يُدفع الإيجار مباشرة للمضيف نقدًا عند لقائكما. الإلغاء:",
  "Bedly ne perçoit que ses frais de service, payés en ligne au moment de la réservation. Le loyer se règle en espèces directement à l’hôte, lors de la remise des clés.": "لا يتقاضى Bedly سوى رسوم الخدمة، وتُدفع عبر الإنترنت عند الحجز. أما الإيجار فيُدفع نقدًا مباشرة للمضيف عند تسليم المفاتيح.",
  "Bedly ouvre dans": "يفتح Bedly في",
  "Bedly sur Instagram (@bedly.ma)": "Bedly على إنستغرام (@bedly.ma)",
  "Bedly vient d’ouvrir. Les premières chambres et colocations arrivent — et si vous avez un logement à louer, vous pouvez être le premier à publier.": "افتُتح Bedly للتو. أولى الغرف والمساكن المشتركة في الطريق — وإن كان لديك سكن للإيجار، يمكنك أن تكون أول من ينشر.",
  "Bedly, accueil": "Bedly، الصفحة الرئيسية",
  "Bénéficiaire": "المستفيد",
  "Benguerir": "ابن جرير",
  "Bienvenue chez les hôtes": "مرحبًا بك بين المضيفين",
  "Bienvenue chez les hôtes.": "مرحبًا بك بين المضيفين.",
  "Bienvenue sur Bedly": "مرحبًا بك في Bedly",
  "Bienvenue, {name} !": "مرحبًا، {name}!",
  "Bio": "نبذة",
  "Bloqué": "محجوز",
  "Bloquer": "إغلاق",
  "Bloquer des dates": "إغلاق تواريخ",
  "Bon retour !": "مرحبًا بعودتك!",
  "Bon retour, {name} !": "مرحبًا بعودتك، {name}!",
  "Brouillon": "مسودة",
  "Budget max (DH)": "الميزانية القصوى (درهم)",
  "Budget max (DH/mois)": "الميزانية القصوى (درهم/شهر)",
  "Budget max (DH/nuit)": "الميزانية القصوى (درهم/ليلة)",
  "Budget min (DH/mois)": "الميزانية الدنيا (درهم/شهر)",
  "Bureau d’étude": "مكتب للدراسة",
  "C’est noté : vous serez alerté dès qu’un logement arrive à {city}.": "تم: سننبهك فور توفر سكن في {city}.",
  "C’est votre propre demande.": "هذا طلبك الخاص.",
  "Calcul des statistiques…": "جارٍ حساب الإحصائيات…",
  "Calcul du prix…": "جارٍ حساب السعر…",
  "Calcul du remboursement…": "جارٍ حساب المبلغ المسترد…",
  "Calendrier": "التقويم",
  "Carte": "الخريطة",
  "Carte bancaire (CMI)": "البطاقة البنكية (CMI)",
  "Carte de séjour": "بطاقة الإقامة",
  "Casablanca": "الدار البيضاء",
  "Ce code a expiré — demandez-en un nouveau.": "انتهت صلاحية هذا الرمز — اطلب رمزًا جديدًا.",
  "Ce code affilié n’existe pas ou n’est plus actif": "رمز الشريك هذا غير موجود أو لم يعد نشطًا",
  "Ce code est déjà pris.": "هذا الرمز مستخدم بالفعل.",
  "Ce code n’est pas correct.": "هذا الرمز غير صحيح.",
  "Ce compte est suspendu.": "هذا الحساب معلّق.",
  "Ce compte n’est pas actif.": "هذا الحساب غير نشط.",
  "Ce compte n’existe plus.": "هذا الحساب لم يعد موجودًا.",
  "Ce compte ne peut pas envoyer de messages.": "لا يمكن لهذا الحساب إرسال رسائل.",
  "Ce fichier est une image, pas une vidéo.": "هذا الملف صورة وليس فيديو.",
  "Ce fichier n’est pas une image JPEG, PNG, WebP ou AVIF.": "هذا الملف ليس صورة JPEG أو PNG أو WebP أو AVIF.",
  "Ce fichier n’est pas une vidéo MP4, MOV ou WebM.": "هذا الملف ليس فيديو MP4 أو MOV أو WebM.",
  "Ce lien de réinitialisation a expiré.": "انتهت صلاحية رابط إعادة التعيين.",
  "Ce lien de réinitialisation n’est pas valide.": "رابط إعادة التعيين هذا غير صالح.",
  "Ce logement accueille au plus {count} personne(s).": "يستقبل هذا السكن {count} شخص كحد أقصى.",
  "Ce logement n’accepte pas de réservations pour le moment.": "هذا السكن لا يقبل الحجوزات حاليًا.",
  "Ce logement n’est pas proposé pour ce type de séjour.": "هذا السكن غير متاح لهذا النوع من الإقامة.",
  "Ce logement ne vous appartient pas.": "هذا السكن لا يخصك.",
  "Ce navigateur ne permet pas les notifications. Essayez Chrome, Edge, Firefox ou Safari à jour.": "هذا المتصفح لا يدعم الإشعارات. جرّب إصدارًا حديثًا من Chrome أو Edge أو Firefox أو Safari.",
  "Ce numéro appartient déjà à un autre compte.": "هذا الرقم مرتبط بحساب آخر.",
  "Ce point est hors du Maroc.": "هذا الموقع خارج المغرب.",
  "Centre-ville — déplacez le point": "وسط المدينة — حرّك الدبوس",
  "Certains champs sont invalides.": "بعض الحقول غير صالحة.",
  "Ces dates ne sont pas disponibles.": "هذه التواريخ غير متاحة.",
  "Ces dates ne sont plus disponibles. Essayez d’autres dates.": "هذه التواريخ لم تعد متاحة. جرّب تواريخ أخرى.",
  "Ces dates viennent d’être prises pour ce logement.": "تم حجز هذه التواريخ للتو في هذا السكن.",
  "Ces frais ont déjà été réglés.": "تم دفع هذه الرسوم مسبقًا.",
  "Cet élément ne vous appartient pas.": "هذا العنصر لا يخصك.",
  "Cette action n’est plus possible.": "لم يعد هذا الإجراء ممكنًا.",
  "Cette annonce a des réservations en cours — mettez-la en pause au lieu de la supprimer.": "لهذا الإعلان حجوزات جارية — أوقفه مؤقتًا بدل حذفه.",
  "Cette annonce a été supprimée.": "تم حذف هذا الإعلان.",
  "Cette annonce est déjà en ligne.": "هذا الإعلان منشور بالفعل.",
  "Cette annonce n’est pas encore prête à être publiée.": "هذا الإعلان غير جاهز للنشر بعد.",
  "Cette annonce n’est pas publique (": "هذا الإعلان غير منشور (",
  "Cette chambre a des réservations en cours.": "لهذه الغرفة حجوزات جارية.",
  "Cette chambre ne vous appartient pas.": "هذه الغرفة لا تخصك.",
  "Cette conversation ne vous appartient pas.": "هذه المحادثة لا تخصك.",
  "Cette demande ne vous appartient pas.": "هذا الطلب لا يخصك.",
  "Cette photo ne vous appartient pas.": "هذه الصورة لا تخصك.",
  "Cette réservation est déjà confirmée.": "هذا الحجز مؤكد بالفعل.",
  "Cette réservation est introuvable.": "لم يتم العثور على هذا الحجز.",
  "Cette réservation n’a rien à payer en ligne.": "لا يوجد ما يُدفع عبر الإنترنت لهذا الحجز.",
  "Cette réservation ne peut plus changer de statut.": "لم يعد بالإمكان تغيير حالة هذا الحجز.",
  "Cette réservation ne vous appartient pas.": "هذا الحجز لا يخصك.",
  "Cette valeur est déjà utilisée.": "هذه القيمة مستخدمة بالفعل.",
  "Cette vérification a déjà été traitée.": "تمت معالجة هذا التحقق بالفعل.",
  "chambre": "غرفة",
  "Chambre": "غرفة",
  "Chambre {number}": "الغرفة {number}",
  "Chambre au mois": "غرفة بالشهر",
  "Chambre lumineuse dans un appartement calme, à dix minutes à pied du campus…": "غرفة مضيئة في شقة هادئة، على بعد عشر دقائق مشيًا من الحرم الجامعي…",
  "Chambre meublée": "غرفة مفروشة",
  "Chambre meublée à Agdal, 10 min de l’UM5": "غرفة مفروشة في أكدال، على بعد 10 دقائق من جامعة محمد الخامس",
  "Chambre partagée": "غرفة مشتركة",
  "Chambre privée": "غرفة خاصة",
  "Chambre supprimée.": "تم حذف الغرفة.",
  "Chambre sur cour": "غرفة مطلة على الفناء",
  "chambre(s)": "غرفة (غرف)",
  "chambre(s) ·": "غرفة (غرف) ·",
  "Chambres": "الغرف",
  "Chambres à louer séparément (optionnel)": "غرف للإيجار بشكل منفصل (اختياري)",
  "Chambres au mois": "غرف بالشهر",
  "Champ obligatoire.": "حقل إلزامي.",
  "Changer d’adresse demande de vérifier la nouvelle avec un code.": "تغيير العنوان يتطلب التحقق من العنوان الجديد برمز.",
  "Changer le mot de passe": "تغيير كلمة المرور",
  "Changer le mot de passe déconnecte tous vos appareils. C’est voulu.": "تغيير كلمة المرور يُخرجك من جميع أجهزتك. هذا مقصود.",
  "Chaque hôte est identifié par sa carte nationale avant publication.": "يتم التحقق من هوية كل مضيف ببطاقته الوطنية قبل النشر.",
  "Chargement de Google…": "جارٍ تحميل Google…",
  "Chargement de l’annonce…": "جارٍ تحميل الإعلان…",
  "Chargement de l’espace admin…": "جارٍ تحميل مساحة الإدارة…",
  "Chargement de la messagerie…": "جارٍ تحميل الرسائل…",
  "Chargement de votre session…": "جارٍ تحميل جلستك…",
  "Chargement des annonces…": "جارٍ تحميل الإعلانات…",
  "Chargement des demandes…": "جارٍ تحميل الطلبات…",
  "Chargement du tableau de bord…": "جارٍ تحميل لوحة التحكم…",
  "Chargement…": "جارٍ التحميل…",
  "Charges incluses · sans frais cachés": "التكاليف مشمولة · بدون رسوم خفية",
  "Chauffage": "تدفئة",
  "Chercher une colocation": "البحث عن سكن مشترك",
  "Choisissez au moins un type de location.": "اختر نوع إيجار واحدًا على الأقل.",
  "Choisissez un fichier.": "اختر ملفًا.",
  "Choisissez une valeur de la liste.": "اختر قيمة من القائمة.",
  "Cible de téléversement": "وجهة الرفع",
  "CIN déjà vérifiée — rien à renvoyer.": "تم التحقق من البطاقة الوطنية مسبقًا — لا حاجة لإعادة الإرسال.",
  "CIN vérifiée": "بطاقة وطنية موثّقة",
  "Climatisation": "مكيف هواء",
  "Club étudiant UM5, @influenceuse…": "نادي طلبة جامعة محمد الخامس، ‎@مؤثرة…",
  "CNIE — carte nationale électronique": "البطاقة الوطنية الإلكترونية",
  "Code": "الرمز",
  "Code (optionnel)": "الرمز (اختياري)",
  "Code à 6 chiffres": "رمز من 6 أرقام",
  "Code à 6 chiffres envoyé à": "رمز من 6 أرقام أُرسل إلى",
  "Code affilié (optionnel)": "رمز الشريك (اختياري)",
  "Code d’affiliation inconnu.": "رمز الشريك غير معروف.",
  "Code de paiement en agence": "رمز الدفع في الوكالة",
  "Code de vérification": "رمز التحقق",
  "Code envoyé à": "أُرسل الرمز إلى",
  "Coloc": "سكن مشترك",
  "coloc ·": "سكن مشترك ·",
  "coloc recherché(s)": "شريك (شركاء) سكن مطلوب",
  "Colocataires recherchés": "شركاء السكن المطلوبون",
  "Colocation": "سكن مشترك",
  "Colocation (chambres partagées entre locataires)": "سكن مشترك (غرف مشتركة بين المستأجرين)",
  "Colocations": "السكن المشترك",
  "Colocations entre étudiants au Maroc": "سكن مشترك بين الطلاب في المغرب",
  "Colocations, chambres au mois et locations au Maroc.": "سكن مشترك وغرف بالشهر وإيجارات في المغرب.",
  "Colocations, chambres au mois et nuitées.": "سكن مشترك، غرف بالشهر وإقامات بالليلة.",
  "Colocations, chambres au mois et séjours à la nuit — hôtes vérifiés, logements visités. Vous ne payez en ligne que les frais de service ; le loyer se règle en main propre.": "سكن مشترك وغرف بالشهر وإقامات بالليلة — مضيفون موثّقون ومساكن تمت زيارتها. لا تدفع عبر الإنترنت سوى رسوم الخدمة؛ أما الإيجار فيُدفع يدًا بيد.",
  "Colocations, chambres et locations": "سكن مشترك وغرف وكراء",
  "Colocations, chambres et locations au Maroc": "سكن مشترك وغرف وكراء في المغرب",
  "Colocations, chambres étudiantes au mois et locations à la nuit partout au Maroc. Annonces visitées par Bedly, hôtes vérifiés, réservation en ligne : vous ne payez en ligne que les frais Bedly, le loyer se règle en main propre.": "سكن مشترك وغرف طلابية بالشهر وكراء بالليلة في جميع أنحاء المغرب. إعلانات زارتها Bedly، مضيفون موثّقون، حجز عبر الإنترنت: تدفع رسوم Bedly فقط عبر الإنترنت، ويُدفع الإيجار يدًا بيد.",
  "Commencer la vérification": "بدء التحقق",
  "Commencez une conversation depuis une annonce ou une demande de colocation.": "ابدأ محادثة من إعلان أو طلب سكن مشترك.",
  "Comment louez-vous ?": "كيف تؤجّر؟",
  "Comment réglez-vous les frais de service ?": "كيف ستدفع رسوم الخدمة؟",
  "Communiquée au locataire une fois la réservation confirmée.": "يُرسل إلى المستأجر بعد تأكيد الحجز.",
  "Compte": "الحساب",
  "Compte réactivé.": "تمت إعادة تفعيل الحساب.",
  "Compte supprimé.": "تم حذف الحساب.",
  "Compte suspendu.": "تم تعليق الحساب.",
  "Concierge": "حارس العمارة",
  "Conditions, contact, commission convenue…": "الشروط، جهة الاتصال، العمولة المتفق عليها…",
  "Confirmée": "مؤكد",
  "confirmées": "مؤكدة",
  "Confirmées": "المؤكدة",
  "confirmées au total": "مؤكدة في المجموع",
  "Confirmer l’annulation": "تأكيد الإلغاء",
  "Confirmer le refus": "تأكيد الرفض",
  "Connectez-vous pour continuer.": "سجّل الدخول للمتابعة.",
  "Connectez-vous pour retrouver vos réservations.": "سجّل الدخول للاطلاع على حجوزاتك.",
  "Connexion": "تسجيل الدخول",
  "Connexion…": "جارٍ تسجيل الدخول…",
  "Contacter l’hôte": "التواصل مع المضيف",
  "Continuer": "متابعة",
  "Conversation introuvable": "المحادثة غير موجودة",
  "Conversion": "نسبة التحويل",
  "Coordonnées": "معلومات الاتصال",
  "Coordonnées de versement": "معلومات الدفع",
  "Copié": "تم النسخ",
  "Copier": "نسخ",
  "courtes vidéos pour faire visiter le logement —": "مقاطع فيديو قصيرة لعرض السكن —",
  "Couverture": "صورة الغلاف",
  "Création…": "جارٍ الإنشاء…",
  "crédits": "الحقوق",
  "Crédits photos": "حقوق الصور",
  "Créer l’affilié": "إنشاء الشريك",
  "Créer mon compte": "إنشاء حسابي",
  "Créer un compte": "إنشاء حساب",
  "Créer un compte pour publier": "أنشئ حسابًا للنشر",
  "Créer une annonce": "إنشاء إعلان",
  "Créez un code pour un partenaire : chaque inscription faite avec lui sera suivie ici.": "أنشئ رمزًا لشريك: سيتم تتبع كل تسجيل يتم به هنا.",
  "Croissance des membres": "نمو الأعضاء",
  "Cuisine": "مطبخ",
  "Cuisine équipée": "مطبخ مجهّز",
  "Date d’emménagement": "تاريخ الانتقال",
  "Date de naissance": "تاريخ الميلاد",
  "date inconnue": "تاريخ غير معروف",
  "Date invalide.": "تاريخ غير صالح.",
  "Dates": "التواريخ",
  "Débloquer": "إعادة الفتح",
  "Décision de modération": "قرار إشراف",
  "Déconnecté de tous les appareils.": "تم تسجيل الخروج من جميع الأجهزة.",
  "Déjà un compte ?": "لديك حساب بالفعل؟",
  "demande → réservation": "طلب ← حجز",
  "Demande acceptée": "تم قبول الطلب",
  "Demande acceptée.": "تم قبول الطلب.",
  "Demande acceptée. Le locataire peut régler les frais de service.": "تم قبول الطلب. يمكن للمستأجر الآن دفع رسوم الخدمة.",
  "Demande envoyée": "تم إرسال الطلب",
  "Demande envoyée à l’hôte.": "تم إرسال الطلب إلى المضيف.",
  "Demande expirée": "انتهت صلاحية الطلب",
  "Demande introuvable": "الطلب غير موجود",
  "Demande mise à jour.": "تم تحديث الطلب.",
  "Demande publiée. Les hôtes et colocataires peuvent vous écrire.": "تم نشر الطلب. يمكن للمضيفين وشركاء السكن مراسلتك الآن.",
  "Demande refusée": "تم رفض الطلب",
  "Demande refusée.": "تم رفض الطلب.",
  "Demande refusée. Les dates sont libérées.": "تم رفض الطلب. أصبحت التواريخ متاحة من جديد.",
  "Demande supprimée.": "تم حذف الطلب.",
  "demande(s)": "طلب (طلبات)",
  "Demandes": "الطلبات",
  "Demandes de colocation": "طلبات السكن المشترك",
  "Demandes en attente": "طلبات قيد الانتظار",
  "Demandes par type": "الطلبات حسب النوع",
  "Demandes récentes": "أحدث الطلبات",
  "Demandez au plus {count} nuits à la fois.": "اطلب {count} ليلة كحد أقصى في كل مرة.",
  "Départ": "المغادرة",
  "depuis le lancement": "منذ الإطلاق",
  "Des corrections sont nécessaires avant publication.": "يلزم إجراء بعض التعديلات قبل النشر.",
  "des inscrits de la période": "من مسجلي هذه الفترة",
  "Désactiver sur cet appareil": "إيقاف على هذا الجهاز",
  "Description": "الوصف",
  "Détail du prix": "تفاصيل السعر",
  "Détails": "التفاصيل",
  "Deux lignes pour vous présenter aux hôtes.": "سطران لتقديم نفسك للمضيفين.",
  "Devenez hôte en trois étapes. Publication gratuite.": "كن مضيفًا في ثلاث خطوات. النشر مجاني.",
  "Devenir hôte": "كن مضيفًا",
  "DH / mois": "درهم / شهر",
  "DH / nuit": "درهم / ليلة",
  "Dim": "أحد",
  "Disponible": "متاح",
  "Disponible du": "متاح من",
  "Document": "الوثيقة",
  "Doit être au moins {n}.": "يجب أن يكون {n} على الأقل.",
  "Doit être au plus {n}.": "يجب أن يكون {n} كحد أقصى.",
  "Doit être inférieur à {n}.": "يجب أن يكون أقل من {n}.",
  "Doit être supérieur à {n}.": "يجب أن يكون أكبر من {n}.",
  "Donnez un titre à votre annonce.": "أعطِ إعلانك عنوانًا.",
  "Du": "من",
  "Durée": "المدة",
  "Durée du bail": "مدة العقد",
  "Eau chaude": "ماء ساخن",
  "Écrire mon avis": "اكتب تقييمي",
  "Écrivez à un hôte depuis une annonce, ou répondez à une demande de colocation.": "راسل مضيفًا من إعلان، أو ردّ على طلب سكن مشترك.",
  "Écrivez votre message…": "اكتب رسالتك…",
  "El Jadida": "الجديدة",
  "Élargissez le budget ou changez de ville.": "وسّع ميزانيتك أو غيّر المدينة.",
  "Elle a peut-être été retirée ou mise en pause par son hôte.": "ربما أزاله مضيفه أو أوقفه مؤقتًا.",
  "Elle sera en ligne après la visite de vérification Bedly, sous 48 h. Vous pouvez déjà la modifier depuis votre tableau de bord.": "سيُنشر بعد زيارة التحقق من Bedly خلال 48 ساعة. يمكنك تعديله الآن من لوحة التحكم.",
  "Email": "البريد الإلكتروني",
  "Email :": "البريد الإلكتروني:",
  "Email non vérifié": "البريد الإلكتروني غير موثّق",
  "Email ou téléphone": "البريد الإلكتروني أو الهاتف",
  "Email vérifié": "البريد الإلكتروني موثّق",
  "Email vérifié. Bienvenue sur Bedly.": "تم توثيق البريد الإلكتروني. مرحبًا بك في Bedly.",
  "Email, téléphone ou mot de passe incorrect.": "البريد الإلكتروني أو الهاتف أو كلمة المرور غير صحيحة.",
  "Emails vérifiés": "رسائل بريد موثّقة",
  "Emménagement": "الانتقال",
  "En attente de la réponse de l’hôte. Vous pourrez régler les frais de service dès qu’il accepte — vous recevrez une notification.": "في انتظار رد المضيف. يمكنك دفع رسوم الخدمة بمجرد قبوله — وستتلقى إشعارًا.",
  "En attente de visite": "في انتظار الزيارة",
  "En configuration locale le prestataire est notre propre file de modération : un administrateur validera depuis l’espace admin.": "في الإعداد المحلي، مزوّد الخدمة هو قائمة المراجعة الخاصة بنا: سيوافق مسؤول من مساحة الإدارة.",
  "En continuant vous acceptez les conditions d’utilisation et la politique de confidentialité de Bedly.": "بالمتابعة، فإنك توافق على شروط الاستخدام وسياسة الخصوصية لـ Bedly.",
  "En cours de vérification": "قيد التحقق",
  "En cours ou à venir": "جارية أو قادمة",
  "en espèces": "نقدًا",
  "En espèces, à l’hôte, à la remise des clés": "نقدًا، للمضيف، عند تسليم المفاتيح",
  "En espèces, à la remise des clés, sans commission": "نقدًا عند تسليم المفاتيح، بدون عمولة",
  "En ligne": "منشور",
  "En pause": "متوقف مؤقتًا",
  "English": "English",
  "Enregistrées": "المحفوظة",
  "Enregistrement…": "جارٍ الحفظ…",
  "Enregistrer": "حفظ",
  "Enregistrer le RIB": "حفظ الحساب البنكي",
  "ENSA Kénitra": "المدرسة الوطنية للعلوم التطبيقية بالقنيطرة",
  "Entre": "بين",
  "Entre 7 jours et 48 h": "بين 7 أيام و48 ساعة",
  "Entrez le code reçu": "أدخل الرمز الذي تلقيته",
  "Entrez une adresse email valide.": "أدخل بريدًا إلكترونيًا صالحًا.",
  "Entrez votre mot de passe.": "أدخل كلمة المرور.",
  "Envoi de la vidéo…": "جارٍ رفع الفيديو…",
  "Envoi…": "جارٍ الإرسال…",
  "Envoyé": "أُرسل",
  "Envoyé à": "أُرسل إلى",
  "Envoyée pour vérification. Visite sous 48 h.": "أُرسل للمراجعة. زيارة خلال 48 ساعة.",
  "Envoyer": "إرسال",
  "Envoyer la demande": "إرسال الطلب",
  "Envoyer le code": "إرسال الرمز",
  "Envoyer mon avis": "إرسال تقييمي",
  "Envoyer pour vérification": "إرسال للمراجعة",
  "Envoyer un test": "إرسال تجربة",
  "Envoyer vos documents": "أرسل وثائقك",
  "Envoyez le recto, le verso et un selfie au prestataire via le lien ci-dessous. Ce lien expire le": "أرسل الوجه الأمامي والخلفي وصورة شخصية إلى مزوّد الخدمة عبر الرابط أدناه. تنتهي صلاحية هذا الرابط في",
  "Équipements": "التجهيزات",
  "Espace administrateur": "مساحة الإدارة",
  "Espèces": "نقدًا",
  "Espèces à l’arrivée + acompte": "نقدًا عند الوصول + عربون",
  "Essayez d’élargir votre budget, de changer de ville ou de retirer quelques filtres.": "جرّب توسيع ميزانيتك أو تغيير المدينة أو إزالة بعض الفلاتر.",
  "Est-ce toujours disponible ?": "هل ما زال متاحًا؟",
  "Étape": "الخطوة",
  "Être alerté quand un logement arrive": "نبّهني عند توفر سكن",
  "Étudiante en médecine à l’UM5, calme et organisée, non-fumeuse…": "طالبة طب في جامعة محمد الخامس، هادئة ومنظمة، غير مدخنة…",
  "Étudiants et jeunes actifs qui cherchent des colocataires.": "طلاب وشباب عاملون يبحثون عن شركاء سكن.",
  "Ex : 2 500 DH": "مثال: 2 500 درهم",
  "Ex : 400 DH": "مثال: 400 درهم",
  "Exactement comme sur votre pièce d’identité.": "تمامًا كما في وثيقة هويتك.",
  "Exécuter maintenant": "تشغيل الآن",
  "Exécution…": "جارٍ التشغيل…",
  "Expirée": "منتهية الصلاحية",
  "Expirer les demandes sans réponse, clôturer les séjours terminés, publier les avis dus après 14 jours, expirer les demandes de colocation dépassées. Le planificateur fait la même chose toutes les 5 minutes ; ce bouton la déclenche maintenant.": "إنهاء الطلبات التي لم يُرد عليها، وإغلاق الإقامات المنتهية، ونشر التقييمات المستحقة بعد 14 يومًا، وإنهاء طلبات السكن المشترك المنتهية. يقوم المُجدول بذلك كل 5 دقائق؛ وهذا الزر يشغّله الآن.",
  "Explorer": "استكشاف",
  "Explorer les logements": "استكشاف المساكن",
  "Explorer par ville": "استكشف حسب المدينة",
  "Faites glisser le repère — ou touchez la carte — jusqu’à la porte du logement. Position exacte, visible de vous seul : sur la carte publique, les locataires verront une zone d’environ 300 m autour de ce point.": "اسحب العلامة — أو المس الخريطة — حتى باب السكن. الموقع الدقيق لا يظهر إلا لك: على الخريطة العامة، سيرى المستأجرون منطقة تقارب 300 متر حول هذه النقطة.",
  "Faites vérifier votre identité avant de publier.": "تحقّق من هويتك قبل النشر.",
  "Femmes uniquement": "للنساء فقط",
  "Fermer": "إغلاق",
  "Fermer le menu": "إغلاق القائمة",
  "Fès": "فاس",
  "Fichier trop lourd.": "الملف كبير جدًا.",
  "Fin le {date}": "ينتهي في {date}",
  "Force majeure": "قوة قاهرة",
  "Format de fichier non pris en charge.": "صيغة الملف غير مدعومة.",
  "Format invalide.": "صيغة غير صالحة.",
  "Frais Bedly (": "رسوم Bedly (",
  "Frais Bedly encaissés": "رسوم Bedly المحصّلة",
  "Frais Bedly inclus · loyer en main propre": "رسوم Bedly مشمولة · الإيجار يُدفع يدًا بيد",
  "Frais de service Bedly": "رسوم خدمة Bedly",
  "Frais de service Bedly (": "رسوم خدمة Bedly (",
  "frais en ligne": "رسوم عبر الإنترنت",
  "Frais encaissés": "الرسوم المحصّلة",
  "Frais générés": "الرسوم المحققة",
  "Français": "Français",
  "Généré si vide": "يُنشأ تلقائيًا إذا تُرك فارغًا",
  "Gérer": "إدارة",
  "Gérer mon annonce": "إدارة إعلاني",
  "Google n’a pas fourni d’adresse email.": "لم يقدّم Google عنوان بريد إلكتروني.",
  "Historique": "السجل",
  "Hommes uniquement": "للرجال فقط",
  "Hôte": "المضيف",
  "Hôte :": "المضيف:",
  "Hôte vérifié": "مضيف موثّق",
  "Hôtes": "المضيفون",
  "Hôtes vérifiés": "مضيفون موثّقون",
  "Identité": "الهوية",
  "Identité :": "الهوية:",
  "Identité à vérifier": "هوية بانتظار التحقق",
  "Identité approuvée.": "تمت الموافقة على الهوية.",
  "Identité non vérifiée": "هوية غير موثّقة",
  "Identité refusée.": "تم رفض الهوية.",
  "Identité vérifiée": "الهوية موثّقة",
  "Identité vérifiée. Le badge « Vérifié » apparaît sur votre profil et vos annonces.": "تم توثيق الهوية. تظهر شارة «موثّق» الآن على ملفك الشخصي وإعلاناتك.",
  "Identités": "الهويات",
  "Identités à valider": "هويات بانتظار التحقق",
  "Ifrane": "إفران",
  "Il manque": "ينقص",
  "il y a {count} h": "قبل {count} ساعة",
  "il y a {count} j": "قبل {count} يوم",
  "il y a {count} min": "قبل {count} دقيقة",
  "Image trop lourde : {max} Mo maximum.": "الصورة كبيرة جدًا: {max} ميغابايت كحد أقصى.",
  "Important :": "مهم:",
  "Impossible de calculer le prix": "تعذّر حساب السعر",
  "Impossible de générer un code libre — réessayez.": "تعذّر إنشاء رمز متاح — أعد المحاولة.",
  "Indiquez l’adresse.": "أدخل العنوان.",
  "Indiquez un email ou un numéro de téléphone.": "أدخل بريدًا إلكترونيًا أو رقم هاتف.",
  "Indiquez un prix pour activer ce type de location.": "أدخل سعرًا لتفعيل نوع الكراء هذا.",
  "Indiquez votre nom.": "أدخل اسمك.",
  "Indisponible": "غير متاح",
  "Inscriptions": "التسجيلات",
  "Inscriptions : méthode": "التسجيلات: الطريقة",
  "Inscriptions : provenance": "التسجيلات: المصدر",
  "Inscrit le": "سجّل في",
  "Inscrits": "المسجلون",
  "Instructions": "التعليمات",
  "Instructions de paiement": "تعليمات الدفع",
  "Instructions de paiement générées.": "تم إنشاء تعليمات الدفع.",
  "Interlocuteur": "المحاور",
  "Introuvable : il a peut-être été supprimé.": "غير موجود: ربما تم حذفه.",
  "J’ai envoyé mes documents": "لقد أرسلت وثائقي",
  "J’autorise Bedly à traiter ces données pour vérifier mon identité, conformément à sa politique de confidentialité et à la loi 09-08 sur la protection des données personnelles.": "أأذن لـ Bedly بمعالجة هذه البيانات للتحقق من هويتي، وفقًا لسياسة الخصوصية والقانون 09-08 المتعلق بحماية المعطيات الشخصية.",
  "j)": "ي)",
  "Jamais publique. Elle sert à placer le logement sur la carte, et n’est communiquée au locataire qu’une fois la réservation confirmée.": "لا يُنشر أبدًا. يُستخدم لوضع السكن على الخريطة، ولا يُرسل إلى المستأجر إلا بعد تأكيد الحجز.",
  "Je cherche un logement": "أبحث عن سكن",
  "Je propose un logement": "لدي سكن للإيجار",
  "Jeu": "خميس",
  "Jusqu’à": "حتى",
  "Kénitra": "القنيطرة",
  "L’adresse exacte est communiquée une fois la réservation confirmée — une protection pour l’hôte comme pour vous.": "يُكشف العنوان الدقيق بعد تأكيد الحجز — حماية للمضيف ولك.",
  "L’adresse exacte s’affiche une fois les frais de service réglés.": "يظهر العنوان الدقيق بعد دفع رسوم الخدمة.",
  "L’adresse exacte se débloque dès que les frais de service sont réglés.": "يُكشف العنوان الدقيق فور دفع رسوم الخدمة.",
  "L’adresse ou le point sur la carte est incorrect": "العنوان أو الموقع على الخريطة غير صحيح",
  "L’email n’a pas pu être envoyé. Réessayez dans un instant.": "تعذّر إرسال البريد الإلكتروني. أعد المحاولة بعد لحظة.",
  "L’hôte a 48 h pour répondre. Les dates sont réservées pendant ce délai.": "لدى المضيف 48 ساعة للرد. التواريخ محجوزة خلال هذه المدة.",
  "L’hôte n’a pas encore accepté cette demande.": "لم يقبل المضيف هذا الطلب بعد.",
  "L’hôte n’a pas pu accepter votre demande.": "لم يتمكن المضيف من قبول طلبك.",
  "L’hôte n’a pas répondu à temps pour « {title} ». Les dates sont de nouveau libres : vous pouvez réessayer ou chercher ailleurs.": "لم يرد المضيف في الوقت المناسب على «{title}». أصبحت التواريخ متاحة من جديد: يمكنك إعادة المحاولة أو البحث في مكان آخر.",
  "La connexion Google n’a pas pu être vérifiée.": "تعذّر التحقق من تسجيل الدخول عبر Google.",
  "La connexion Google n’est pas disponible pour le moment.": "تسجيل الدخول عبر Google غير متاح حاليًا.",
  "La date de début est déjà passée.": "تاريخ البداية قد مضى.",
  "La date de fin doit être après la date de début.": "يجب أن يكون تاريخ النهاية بعد تاريخ البداية.",
  "La durée maximale ne peut pas être plus courte que la minimale.": "لا يمكن أن تكون المدة القصوى أقصر من الدنيا.",
  "La file est vide.": "القائمة فارغة.",
  "La position publiée est volontairement décalée d’environ 300 m. L’adresse précise n’est partagée qu’après confirmation de la réservation.": "الموقع المنشور مُزاح عمدًا بنحو 300 متر. لا يُكشف العنوان الدقيق إلا بعد تأكيد الحجز.",
  "La recherche d’adresse a échoué": "فشل البحث عن العنوان",
  "La réservation {reference} n’a pas été payée à temps ; les dates sont libérées.": "لم يُدفع الحجز {reference} في الوقت المناسب؛ أصبحت التواريخ متاحة.",
  "La réservation a été annulée.": "تم إلغاء الحجز.",
  "La réservation est confirmée dès réception du paiement. Vous recevrez une notification.": "يتأكد الحجز فور استلام الدفع. ستتلقى إشعارًا.",
  "La vérification d’identité est requise avant de publier une annonce.": "التحقق من الهوية مطلوب قبل نشر إعلان.",
  "La vérification d’identité est requise avant de publier. Vous pourrez préparer votre annonce en attendant la validation.": "التحقق من الهوية مطلوب قبل النشر. يمكنك تحضير إعلانك في انتظار الموافقة.",
  "La vérification d’identité rassure les hôtes et devient obligatoire pour publier une annonce. Comptez deux minutes.": "التحقق من الهوية يطمئن المضيفين وهو إلزامي لنشر إعلان. يستغرق دقيقتين تقريبًا.",
  "La visite de vérification a été effectuée (active le badge « Visité »)": "تمت زيارة التحقق (تفعّل شارة «تمت زيارته»)",
  "Laisser un avis": "اترك تقييمًا",
  "Laissez un avis — il sera publié quand les deux parties auront répondu.": "اترك تقييمًا — سيُنشر عندما يرد الطرفان.",
  "Laissez un avis sur votre locataire.": "اترك تقييمًا لمستأجرك.",
  "Langue": "اللغة",
  "Latitude": "خط العرض",
  "Le badge Vérifié apparaît maintenant sur votre profil et vos annonces.": "تظهر شارة «موثّق» الآن على ملفك وإعلاناتك.",
  "Le budget maximum ne peut pas être inférieur au minimum.": "لا يمكن أن تكون الميزانية القصوى أقل من الدنيا.",
  "Le code compte 6 chiffres.": "الرمز مكوّن من 6 أرقام.",
  "Le délai de paiement pour « {title} » est passé. Les dates ont été libérées.": "انتهت مهلة الدفع لـ«{title}». تم تحرير التواريخ.",
  "Le dépôt du locataire a été reçu.": "تم استلام دفعة المستأجر.",
  "Le document a expiré": "انتهت صلاحية الوثيقة",
  "Le lien que vous avez suivi ne mène nulle part.": "الرابط الذي اتبعته لا يؤدي إلى أي مكان.",
  "Le locataire a réglé les frais de service : la réservation est confirmée.": "دفع المستأجر رسوم الخدمة: تم تأكيد الحجز.",
  "Le locataire voit": "يرى المستأجر",
  "Le logement correspondait-il à l’annonce ? L’hôte était-il réactif ?": "هل طابق السكن الإعلان؟ هل كان المضيف متجاوبًا؟",
  "Le logement ne correspond pas à la visite": "السكن لا يطابق ما تمت معاينته",
  "Le nom ne correspond pas au compte": "الاسم لا يطابق الحساب",
  "Le paiement des frais pour {reference} n’a pas abouti. Rien n’a été débité ; vous pouvez réessayer avant l’expiration de la demande.": "لم ينجح دفع الرسوم لـ{reference}. لم يُخصم أي مبلغ؛ يمكنك إعادة المحاولة قبل انتهاء صلاحية الطلب.",
  "Le prix minimum est supérieur au prix maximum.": "السعر الأدنى أعلى من السعر الأقصى.",
  "Le prix ne correspond pas au logement": "السعر لا يتناسب مع السكن",
  "Le Registre de Commerce sera demandé par le prestataire.": "سيطلب مزوّد الخدمة السجل التجاري.",
  "Le remboursement porte sur les frais de service. Plus de 7 jours avant : intégral. Entre 7 jours et 48 h : 50 %. Moins de 48 h : non remboursés.": "يشمل الاسترداد رسوم الخدمة. أكثر من 7 أيام قبل الموعد: كامل. بين 7 أيام و48 ساعة: 50٪. أقل من 48 ساعة: غير مسترد.",
  "Le selfie ne correspond pas au document": "الصورة الشخصية لا تطابق الوثيقة",
  "Les charges sont-elles incluses ?": "هل التكاليف مشمولة؟",
  "Les dates sont bloquées jusqu’à votre réponse": "التواريخ محجوزة إلى حين ردك",
  "Les demandes de réservation apparaîtront ici dès que votre annonce sera en ligne.": "ستظهر طلبات الحجز هنا بمجرد نشر إعلانك.",
  "Les deux avis sont maintenant visibles.": "أصبح التقييمان مرئيين الآن.",
  "Les deux avis sont publiés.": "تم نشر التقييمين.",
  "Les disponibilités se gèrent depuis le calendrier de l’annonce, après publication.": "تُدار التوافرات من تقويم الإعلان بعد النشر.",
  "Les essentiels": "الأساسيات",
  "Les notifications ont été refusées pour Bedly.": "تم رفض الإشعارات لـBedly.",
  "Les notifications sont activées": "تم تفعيل الإشعارات",
  "Les notifications sont bloquées pour Bedly dans ce navigateur. Autorisez-les dans les réglages du site (le cadenas à côté de l’adresse), puis rechargez la page.": "الإشعارات محظورة لـBedly في هذا المتصفح. اسمح بها من إعدادات الموقع (رمز القفل بجانب العنوان)، ثم أعد تحميل الصفحة.",
  "Les photos contiennent du texte ou des numéros": "تحتوي الصور على نص أو أرقام",
  "Les photos des villes proviennent de Wikimedia Commons, sous licences libres. Elles ont été recadrées et redimensionnées pour l’affichage. Merci à leurs auteurs.": "صور المدن مأخوذة من ويكيميديا كومنز بتراخيص حرة. تم قصّها وتغيير حجمها للعرض. شكرًا لمؤلفيها.",
  "Les premières annonces arrivent": "أولى الإعلانات في الطريق",
  "Les réponses des hôtes, les confirmations et les messages arrivent ici.": "تصل هنا ردود المضيفين والتأكيدات والرسائل.",
  "Les vues, demandes et revenus apparaîtront ici après la publication de votre première annonce.": "ستظهر المشاهدات والطلبات والإيرادات هنا بعد نشر إعلانك الأول.",
  "Lettres, chiffres, - ou _, de 3 à 32 caractères.": "حروف وأرقام و- أو _، من 3 إلى 32 حرفًا.",
  "Licence :": "الترخيص:",
  "Lien d’inscription": "رابط التسجيل",
  "Liste": "القائمة",
  "lit": "سرير",
  "lit(s)": "سرير (أسرّة)",
  "lit(s) ·": "سرير (أسرّة) ·",
  "Lits": "الأسرّة",
  "Localisation": "الموقع",
  "Localiser": "تحديد الموقع",
  "Locataire": "المستأجر",
  "Location à la nuit": "إيجار بالليلة",
  "Location au mois": "إيجار بالشهر",
  "Locations à la nuit": "كراء بالليلة",
  "Logement": "سكن",
  "Logement entier": "سكن كامل",
  "Logements visités": "مساكن تمت زيارتها",
  "Longitude": "خط الطول",
  "Loyer payé en main propre": "الإيجار يُدفع يدًا بيد",
  "Lun": "اثنين",
  "Ma demande de colocation": "طلب السكن المشترك الخاص بي",
  "Machine à laver": "غسالة",
  "Maintenance": "الصيانة",
  "Mar": "ثلاثاء",
  "Maroc": "المغرب",
  "Marrakech": "مراكش",
  "Masquer le mot de passe": "إخفاء كلمة المرور",
  "Masquer les filtres": "إخفاء الفلاتر",
  "Masquer les inscrits": "إخفاء المسجلين",
  "Meilleurs affiliés (": "أفضل الشركاء (",
  "Meknès": "مكناس",
  "Membre": "العضو",
  "Membre depuis": "عضو منذ",
  "Membres": "الأعضاء",
  "Menu": "القائمة",
  "Menu du compte": "قائمة الحساب",
  "Mer": "أربعاء",
  "Mes demandes": "طلباتي",
  "Mes réservations": "حجوزاتي",
  "Message": "رسالة",
  "Message à l’hôte (optionnel)": "رسالة إلى المضيف (اختياري)",
  "Message du locataire": "رسالة المستأجر",
  "Message envoyé.": "تم إرسال الرسالة.",
  "Messages": "الرسائل",
  "Messages échangés": "الرسائل المتبادلة",
  "Mettre en pause": "إيقاف مؤقت",
  "Mettre en pause la retire des résultats sans supprimer vos données.": "الإيقاف المؤقت يزيله من النتائج دون حذف بياناتك.",
  "Meublé": "مفروش",
  "Mixte": "مختلط",
  "Mo maximum chacune (environ une minute en 720p).": "ميغابايت كحد أقصى لكل فيديو (دقيقة تقريبًا بدقة 720p).",
  "Mode de location": "نوع الإيجار",
  "Mode développement : le code est": "وضع التطوير: الرمز هو",
  "Mode économe — actualisation toutes les 15 s": "وضع الاقتصاد — تحديث كل 15 ثانية",
  "Mode hôte": "وضع المضيف",
  "Modifier": "تعديل",
  "Modifier ma demande": "تعديل طلبي",
  "Moins de 48 h": "أقل من 48 ساعة",
  "Moins de filtres": "فلاتر أقل",
  "mois ·": "شهر ·",
  "Mois min.": "أقل عدد أشهر",
  "Mois minimum": "الحد الأدنى من الأشهر",
  "Mon compte": "حسابي",
  "Montants en dirhams (MAD), taxes incluses.": "المبالغ بالدرهم (MAD)، شاملة الضرائب.",
  "Mot de passe": "كلمة المرور",
  "Mot de passe actuel": "كلمة المرور الحالية",
  "Mot de passe modifié. Connectez-vous.": "تم تغيير كلمة المرور. سجّل الدخول.",
  "Mot de passe modifié. Reconnectez-vous.": "تم تغيير كلمة المرور. سجّل الدخول من جديد.",
  "Mot de passe oublié": "نسيت كلمة المرور",
  "Mot de passe oublié ?": "نسيت كلمة المرور؟",
  "Motif (optionnel)": "السبب (اختياري)",
  "Motif du refus (envoyé à la personne)": "سبب الرفض (يُرسل إلى الشخص)",
  "Naissance": "الميلاد",
  "Nationalité": "الجنسية",
  "Navigation": "التنقل",
  "Navigation principale": "التنقل الرئيسي",
  "Ne ratez aucune demande": "لا تفوّت أي طلب",
  "Niveau": "المستوى",
  "Nom": "الاسم",
  "Nom complet": "الاسم الكامل",
  "Nom de la chambre": "اسم الغرفة",
  "Nom, téléphone ou email": "الاسم أو الهاتف أو البريد الإلكتروني",
  "non approuvée": "غير مقبولة",
  "Non précisé": "غير محدد",
  "Non précisée": "غير محدد",
  "non renseignée": "غير مُدخلة",
  "non vérifié": "غير موثّق",
  "Non vérifiée": "غير موثّقة",
  "Non-fumeur": "غير مدخن",
  "Non-fumeur. Calme après 22 h. Invités jusqu’à 22 h.": "ممنوع التدخين. هدوء بعد العاشرة ليلًا. الزوار حتى العاشرة ليلًا.",
  "Note globale": "التقييم العام",
  "Note interne (optionnel)": "ملاحظة داخلية (اختياري)",
  "Notification de test envoyée.": "تم إرسال إشعار تجريبي.",
  "Notifications": "الإشعارات",
  "Notifications activées sur cet appareil.": "تم تفعيل الإشعارات على هذا الجهاز.",
  "Notifications désactivées sur cet appareil.": "تم إيقاف الإشعارات على هذا الجهاز.",
  "Notifications push": "الإشعارات الفورية",
  "Notifications push (tous vos appareils)": "الإشعارات الفورية (جميع أجهزتك)",
  "Notifications sur cet appareil": "الإشعارات على هذا الجهاز",
  "Notre équipe se déplace sous 48 h et active le badge « Visité ».": "يزور فريقنا السكن خلال 48 ساعة ويفعّل شارة «تمت زيارته».",
  "Notre équipe vérifie les documents sous 24 à 48 heures.": "يراجع فريقنا الوثائق خلال 24 إلى 48 ساعة.",
  "Notre équipe visitera le logement sous 48 h avant publication.": "سيزور فريقنا السكن خلال 48 ساعة قبل النشر.",
  "Notre équipe visitera le logement sous 48 h avant publication. Vous pouvez continuer à le modifier entre-temps.": "سيزور فريقنا السكن خلال 48 ساعة قبل النشر. يمكنك مواصلة تعديله في الأثناء.",
  "Nous envoyons un code à l’adresse email de votre compte.": "نرسل رمزًا إلى البريد الإلكتروني لحسابك.",
  "Nous n’avons pas pu lire la réponse de la banque. Si le montant a été débité, il sera rapproché automatiquement — sinon réessayez.": "تعذّر علينا قراءة رد البنك. إذا تم خصم المبلغ فستتم تسويته تلقائيًا — وإلا فحاول مجددًا.",
  "Nous n’avons pas pu valider votre document.": "لم نتمكن من قبول وثيقتك.",
  "Nous vous enverrons un code par email. Vous pourrez ajouter l’autre rôle plus tard.": "سنرسل لك رمزًا بالبريد الإلكتروني. يمكنك إضافة الدور الآخر لاحقًا.",
  "Nouveau": "جديد",
  "Nouveau code envoyé.": "تم إرسال رمز جديد.",
  "Nouveau logement à {city}": "سكن جديد في {city}",
  "Nouveau message": "رسالة جديدة",
  "Nouveau mot de passe": "كلمة مرور جديدة",
  "Nouveaux logements": "مساكن جديدة",
  "Nouvel affilié": "شريك جديد",
  "Nouvelle adresse vérifiée.": "تم توثيق العنوان الجديد.",
  "Nouvelle conversation": "محادثة جديدة",
  "Nouvelle demande de réservation": "طلب حجز جديد",
  "nuit(s)": "ليلة (ليالٍ)",
  "Nuitée": "بالليلة",
  "Nuits min.": "أقل عدد ليالٍ",
  "Nuits minimum": "الحد الأدنى من الليالي",
  "Numéro ICE (15 chiffres)": "رقم التعريف الموحد للمقاولة (15 رقمًا)",
  "Où se trouve le logement ?": "أين يقع السكن؟",
  "Oujda": "وجدة",
  "Ouvert aux annonces": "مفتوحة للإعلانات",
  "Ouverture…": "جارٍ الفتح…",
  "Ouvrir la messagerie": "فتح الرسائل",
  "Ouvrir le menu": "فتح القائمة",
  "Ouvrir le tableau de bord": "فتح لوحة التحكم",
  "Ouvrir sur Bedly": "افتح على Bedly",
  "Page introuvable": "الصفحة غير موجودة",
  "Paiement": "الدفع",
  "Paiement en cours": "الدفع قيد المعالجة",
  "Paiement reçu. Les frais Bedly sont réglés — le loyer se paie en main propre au rendez-vous.": "تم استلام الدفع. تم دفع رسوم Bedly — ويُدفع الإيجار يدًا بيد عند اللقاء.",
  "Paiement refusé": "تم رفض الدفع",
  "Paiement refusé par la banque. Rien n’a été débité : vous pouvez réessayer ci-dessous.": "رفض البنك الدفع. لم يُخصم أي مبلغ: يمكنك المحاولة مجددًا أدناه.",
  "Par annonce": "حسب الإعلان",
  "par mois et par personne": "في الشهر للشخص",
  "Par sécurité, cette session a été fermée. Reconnectez-vous.": "لحمايتك، تم إغلاق هذه الجلسة. سجّل الدخول من جديد.",
  "Paramètres": "الإعدادات",
  "Parking": "موقف سيارات",
  "Particulier": "فرد",
  "Pas d’avance en ligne": "لا دفعة مسبقة عبر الإنترنت",
  "Pas encore d’avis": "لا توجد تقييمات بعد",
  "Pas encore d’avis. Les avis sont publiés quand les deux parties ont répondu, ou 14 jours après la fin du séjour.": "لا توجد تقييمات بعد. تُنشر التقييمات بعد رد الطرفين، أو بعد 14 يومًا من انتهاء الإقامة.",
  "Pas encore de données.": "لا توجد بيانات بعد.",
  "Pas encore de statistiques": "لا توجد إحصائيات بعد",
  "Pas encore de visites": "لا توجد زيارات بعد",
  "Passées": "السابقة",
  "Passeport": "جواز السفر",
  "Passer en thème clair": "التبديل إلى المظهر الفاتح",
  "Passer en thème sombre": "التبديل إلى المظهر الداكن",
  "Payé en ligne": "مدفوع عبر الإنترنت",
  "Payer les frais de service": "دفع رسوم الخدمة",
  "Payer les frais de service ({amount})": "دفع رسوم الخدمة ({amount})",
  "Personne ne s’est encore inscrit avec ce code.": "لم يسجّل أحد بهذا الرمز بعد.",
  "personne(s)": "شخص (أشخاص)",
  "Peu importe": "لا يهم",
  "Photo": "صورة",
  "Photo :": "الصورة:",
  "Photo de {city}": "صورة {city}",
  "Photo de couverture mise à jour.": "تم تحديث صورة الغلاف.",
  "Photo floue — le texte est illisible": "صورة غير واضحة — النص غير مقروء",
  "photo(s)": "صورة (صور)",
  "photo(s) pour pouvoir publier.": "صورة (صور) لتتمكن من النشر.",
  "Photos": "الصور",
  "Photos : Wikimedia Commons, sous licences libres ·": "الصور: ويكيميديا كومنز، بتراخيص حرة ·",
  "Photos ou informations insuffisantes": "صور أو معلومات غير كافية",
  "photos, prises directement au téléphone : chaque pièce, la cuisine, la salle de bain, la vue. La première devient la couverture.": "صور، مأخوذة مباشرة بهاتفك: كل غرفة، والمطبخ، والحمام، والإطلالة. تصبح الأولى صورة الغلاف.",
  "Placez le point sur la carte et indiquez le quartier.": "ضع الدبوس على الخريطة وأدخل الحي.",
  "Plus de 7 jours avant": "أكثر من 7 أيام قبل",
  "Plus de filtres": "فلاتر إضافية",
  "Plus récentes": "الأحدث",
  "Plus tard": "لاحقًا",
  "Porte blindée": "باب مصفّح",
  "Pour la confiance des locataires comme des hôtes. Environ deux minutes.": "من أجل ثقة المستأجرين والمضيفين على حد سواء. دقيقتان تقريبًا.",
  "Pour que l’hôte ou le locataire puisse vous joindre. Jamais affiché publiquement.": "ليتمكن المضيف أو المستأجر من التواصل معك. لا يُعرض علنًا أبدًا.",
  "Pour recevoir vos revenus d’hôte. Le RIB est transmis au prestataire de paiement et remplacé par un jeton : Bedly n’en garde que les 4 derniers chiffres.": "لتلقي مداخيلك كمضيف. تُرسل المعلومات البنكية إلى مزوّد الدفع وتُستبدل برمز: لا يحتفظ Bedly إلا بآخر 4 أرقام.",
  "Préférence": "التفضيل",
  "Préférence de colocation": "تفضيل شريك السكن",
  "Préparation…": "جارٍ التحضير…",
  "Près de": "بالقرب من",
  "Près de votre université": "بالقرب من جامعتك",
  "Présentez votre logement ou votre recherche…": "قدّم سكنك أو ما تبحث عنه…",
  "Présentez-vous": "قدّم نفسك",
  "Présentez-vous en deux lignes : études, durée souhaitée, date de visite possible…": "قدّم نفسك في سطرين: الدراسة، المدة المرغوبة، موعد الزيارة الممكن…",
  "Privée": "خاصة",
  "Prix & chambres": "الأسعار والغرف",
  "Prix à venir": "السعر قريبًا",
  "Prix affiché frais de service inclus. Vous ne payez en ligne que ces frais ; le loyer se règle en espèces à l’hôte lors de la remise des clés.": "السعر المعروض يشمل رسوم الخدمة. لا تدفع عبر الإنترنت سوى هذه الرسوم؛ أما الإيجار فيُدفع نقدًا للمضيف عند تسليم المفاتيح.",
  "Prix croissant": "السعر: من الأقل إلى الأعلى",
  "Prix décroissant": "السعر: من الأعلى إلى الأقل",
  "Prix non renseigné": "لم يُحدد السعر",
  "Prix par mois (DH)": "السعر في الشهر (درهم)",
  "Prix par nuit (DH)": "السعر في الليلة (درهم)",
  "Proche bus": "قريب من الحافلة",
  "Proche de": "قريب من",
  "Proche tram": "قريب من الترامواي",
  "Profil": "الملف الشخصي",
  "Profil enregistré.": "تم حفظ الملف الشخصي.",
  "Profil enregistré. Un code a été envoyé à votre nouvelle adresse.": "تم حفظ الملف الشخصي. أُرسل رمز إلى عنوانك الجديد.",
  "Profil introuvable": "الملف الشخصي غير موجود",
  "Proximité du campus": "الأقرب إلى الحرم الجامعي",
  "Publiées": "المنشورة",
  "Publier": "نشر",
  "Publier l’annonce": "نشر الإعلان",
  "Publier la demande": "نشر الطلب",
  "Publier un logement": "نشر سكن",
  "Publier une annonce": "نشر إعلان",
  "Publier une demande": "نشر طلب",
  "Publiez chambres, colocations ou nuitées. La publication est gratuite : Bedly prélève une commission uniquement quand une réservation est confirmée.": "انشر غرفًا أو سكنًا مشتركًا أو إقامات بالليلة. النشر مجاني: لا يأخذ Bedly عمولة إلا عند تأكيد الحجز.",
  "Publiez gratuitement. Commission de 8 % du premier mois, uniquement si vous êtes réservé.": "انشر مجانًا. عمولة 8٪ من الشهر الأول، فقط إذا تم حجزك.",
  "Publiez une demande pour que les hôtes et les colocataires vous trouvent.": "انشر طلبًا ليجدك المضيفون وشركاء السكن.",
  "Publiez votre première annonce : photos, prix, disponibilités. Dix minutes suffisent.": "انشر أول إعلان لك: الصور والسعر والتوافر. عشر دقائق تكفي.",
  "Puis-je visiter cette semaine ?": "هل يمكنني الزيارة هذا الأسبوع؟",
  "Quand ?": "متى؟",
  "Quand emménagez-vous ?": "متى ستنتقل؟",
  "Quartier": "الحي",
  "Quartier — ajustez si besoin": "الحي — عدّل إذا لزم الأمر",
  "Quartier souhaité": "الحي المفضل",
  "Que venez-vous faire sur Bedly ?": "ما الذي جاء بك إلى Bedly؟",
  "Quel type de logement ?": "ما نوع السكن؟",
  "Quelle adresse est la bonne ?": "أي عنوان هو الصحيح؟",
  "Quelles dates ?": "أي تواريخ؟",
  "Quelqu’un répond à votre demande": "شخص ما رد على طلبك",
  "Quels équipements ?": "أي تجهيزات؟",
  "Rabat": "الرباط",
  "Réactiver": "إعادة التفعيل",
  "Recherche libre": "بحث حر",
  "Recherche…": "جارٍ البحث…",
  "Rechercher": "بحث",
  "reçues": "مستلمة",
  "Réf.": "المرجع",
  "Référence": "المرجع",
  "Référence à indiquer": "المرجع الواجب ذكره",
  "Référence de paiement inconnue.": "مرجع دفع غير معروف.",
  "Refusée": "مرفوض",
  "refusée par nos équipes": "مرفوضًا من قبل فريقنا",
  "Refuser": "رفض",
  "Refuser cette demande ? Les dates seront libérées.": "رفض هذا الطلب؟ ستصبح التواريخ متاحة.",
  "Réglé par le locataire": "يدفعه المستأجر",
  "Régler les frais de service": "دفع رسوم الخدمة",
  "Règles": "القواعد",
  "Règles de la maison": "قواعد السكن",
  "Réglez le dépôt pour confirmer votre réservation.": "ادفع رسوم الخدمة لتأكيد حجزك.",
  "Réglez les frais de service pour confirmer votre réservation.": "ادفع رسوم الخدمة لتأكيد حجزك.",
  "Réinitialiser": "إعادة تعيين",
  "Réinitialiser les filtres": "إعادة ضبط الفلاتر",
  "Rejeter": "رفض",
  "Remboursement des frais": "استرداد الرسوم",
  "Remboursement estimé des frais : {amount} ({tier}).": "الاسترداد التقديري للرسوم: {amount} ({tier}).",
  "Remettre en ligne": "إعادة النشر",
  "Renvoyée en vérification.": "أُعيد إلى المراجعة.",
  "Renvoyer le code": "إعادة إرسال الرمز",
  "Répondre à {name}": "الرد على {name}",
  "Répondre à cette demande": "الرد على هذا الطلب",
  "Répondre à la demande": "الرد على الطلب",
  "Reprenez les photos en lumière naturelle.": "أعد التقاط الصور في ضوء طبيعي.",
  "Réservation annulée": "تم إلغاء الحجز",
  "Réservation annulée.": "تم إلغاء الحجز.",
  "Réservation confirmée": "تم تأكيد الحجز",
  "Réservation introuvable": "الحجز غير موجود",
  "réservations": "حجوزات",
  "Réservations": "الحجوزات",
  "Réservé": "محجوز",
  "Réserver": "احجز",
  "Réserver cette chambre": "احجز هذه الغرفة",
  "Résoudre": "حل",
  "Résultats classés par distance à": "النتائج مرتبة حسب المسافة إلى",
  "Retirée": "محذوف",
  "Retirer": "إزالة",
  "Retirer cette photo": "إزالة هذه الصورة",
  "Retirer cette vidéo": "إزالة هذا الفيديو",
  "Retirer des favoris": "إزالة من المحفوظات",
  "Retour": "رجوع",
  "Retour à l’accueil": "العودة إلى الرئيسية",
  "Retour à la connexion": "العودة إلى تسجيل الدخول",
  "Retour à mon compte": "العودة إلى حسابي",
  "Retour aux résultats": "العودة إلى النتائج",
  "Revenus": "المداخيل",
  "Revenus attendus": "المداخيل المتوقعة",
  "Revenus confirmés": "المداخيل المؤكدة",
  "RIB (24 chiffres)": "رقم الحساب البنكي (24 رقمًا)",
  "RIB Bedly · sous 24 h ouvrées": "تحويل بنكي إلى Bedly · خلال 24 ساعة عمل",
  "RIB enregistré. Seuls les 4 derniers chiffres sont conservés.": "تم حفظ الحساب البنكي. لا يُحتفظ إلا بآخر 4 أرقام.",
  "Rien à faire": "لا شيء للقيام به",
  "Rôles": "الأدوار",
  "Rue — ajustez si besoin": "الشارع — عدّل إذا لزم الأمر",
  "S’inscrire": "التسجيل",
  "Saisir les coordonnées à la main": "إدخال الإحداثيات يدويًا",
  "Salé": "سلا",
  "Salle de bain dans la chambre": "حمام داخل الغرفة",
  "Salle de bain partagée": "حمام مشترك",
  "Salle de bain privée": "حمام خاص",
  "salle(s) de bain": "حمّام",
  "Salles de bain": "الحمامات",
  "Salma El Amrani": "سلمى العمراني",
  "Sam": "سبت",
  "Se connecter": "تسجيل الدخول",
  "Se déconnecter": "تسجيل الخروج",
  "Se déconnecter partout": "تسجيل الخروج من كل الأجهزة",
  "se règle en espèces directement à l’hôte lors de la remise des clés.": "يُدفع نقدًا مباشرة للمضيف عند تسليم المفاتيح.",
  "Sections": "الأقسام",
  "Sécurité": "الأمان",
  "Séjour minimum :": "الحد الأدنى للإقامة:",
  "Séjour terminé": "انتهت الإقامة",
  "Séjours confirmés": "الإقامات المؤكدة",
  "Selfie effectué": "تم التقاط الصورة الشخصية",
  "Selfie fourni": "تم تقديم الصورة الشخصية",
  "Selfie manquant": "الصورة الشخصية ناقصة",
  "Session de vérification ouverte.": "تم فتح جلسة التحقق.",
  "Seules les images et les vidéos sont acceptées.": "تُقبل الصور والفيديوهات فقط.",
  "Si cette adresse a un compte, un code vient d’être envoyé.": "إذا كان هذا العنوان مرتبطًا بحساب، فقد أُرسل رمز للتو.",
  "Si un partenaire de Bedly vous a donné un code.": "إذا أعطاك أحد شركاء Bedly رمزًا.",
  "Signalé par": "أبلغ عنه",
  "Signalement rejeté.": "تم رفض البلاغ.",
  "Signalement résolu.": "تمت معالجة البلاغ.",
  "Signalements": "البلاغات",
  "Signalements ouverts": "البلاغات المفتوحة",
  "Société / agence immobilière": "شركة / وكالة عقارية",
  "Soyez prévenu sur ce téléphone ou cet ordinateur : nouvelle demande, réservation confirmée, nouveau message — même quand Bedly est fermé.": "تلقَّ التنبيهات على هذا الهاتف أو الحاسوب: طلب جديد، حجز مؤكد، رسالة جديدة — حتى عندما يكون Bedly مغلقًا.",
  "Statistiques": "الإحصائيات",
  "Statut": "الحالة",
  "Statut : {status}": "الحالة: {status}",
  "Statut de l’annonce": "حالة الإعلان",
  "Suivant": "التالي",
  "Supprimer": "حذف",
  "Supprimer définitivement": "حذف نهائي",
  "Supprimer mon compte": "حذف حسابي",
  "Supprimer votre compte ?": "حذف حسابك؟",
  "sur {count} jours": "خلال {count} يومًا",
  "sur 3 —": "من 3 —",
  "Sur iPhone : touchez Partager, puis « Sur l’écran d’accueil ». Ouvrez Bedly depuis la nouvelle icône et activez les notifications.": "على iPhone: المس «مشاركة» ثم «إضافة إلى الشاشة الرئيسية». افتح Bedly من الأيقونة الجديدة وفعّل الإشعارات.",
  "Survolez une barre pour le détail": "مرّر فوق عمود لرؤية التفاصيل",
  "Suspendre": "تعليق",
  "Suspendre {name} ?": "تعليق حساب {name}؟",
  "Suspendu": "معلّق",
  "Ta chambre au Maroc, en 2 minutes": "غرفتك في المغرب في دقيقتين",
  "Tableau de bord": "لوحة التحكم",
  "Tableau de bord hôte": "لوحة تحكم المضيف",
  "Tâches de maintenance": "مهام الصيانة",
  "Tâches exécutées.": "تم تنفيذ المهام.",
  "Tanger": "طنجة",
  "Tarif enregistré.": "تم حفظ السعر.",
  "Taxes incluses": "شامل الضرائب",
  "Téléphone": "الهاتف",
  "Téléphone (optionnel)": "الهاتف (اختياري)",
  "Temps réel actif": "التحديث الفوري مفعّل",
  "Terminée": "منتهية",
  "Tétouan": "تطوان",
  "Thème clair": "المظهر الفاتح",
  "Thème sombre": "المظهر الداكن",
  "Titre": "العنوان",
  "Titre de l’annonce": "عنوان الإعلان",
  "Titulaire": "صاحب الوثيقة",
  "Titulaire du compte": "صاحب الحساب",
  "Total du séjour": "مجموع الإقامة",
  "Touchez le cœur sur une annonce pour la retrouver ici.": "المس القلب على إعلان لتجده هنا.",
  "Touchez une date de début puis une date de fin pour bloquer une période. Les nuits réservées ne peuvent pas être libérées depuis ici — ce serait survendre la chambre.": "المس تاريخ البداية ثم تاريخ النهاية لإغلاق فترة. لا يمكن تحرير الليالي المحجوزة من هنا — فذلك يعني بيع الغرفة مرتين.",
  "Tous": "الكل",
  "Tous les filtres": "كل الفلاتر",
  "Tout est prêt. L’annonce passera en revue avant publication.": "كل شيء جاهز. ستتم مراجعة الإعلان قبل نشره.",
  "Tout marqué comme lu.": "تم تعليم الكل كمقروء.",
  "Tout marquer comme lu": "تعليم الكل كمقروء",
  "Toutes": "الكل",
  "Toutes les villes": "كل المدن",
  "Trier par": "ترتيب حسب",
  "Trop de codes erronés — demandez-en un nouveau.": "رموز خاطئة كثيرة — اطلب رمزًا جديدًا.",
  "Trop de tentatives. Réessayez dans quelques minutes.": "محاولات كثيرة جدًا. أعد المحاولة بعد بضع دقائق.",
  "Trouvé — clôturée": "تم العثور — مغلق",
  "Trouvez votre chambre au Maroc": "اعثر على غرفتك في المغرب",
  "Type": "النوع",
  "Type de location": "نوع الإيجار",
  "Type de séjour": "نوع الإقامة",
  "Types de location proposés": "أنواع الإيجار المعروضة",
  "UM5-2026": "UM5-2026",
  "UM5, UM6P…": "UM5، UM6P…",
  "Un avis a été publié": "تم نشر تقييم",
  "Un compte existe déjà avec ce numéro de téléphone.": "يوجد حساب بهذا الرقم بالفعل.",
  "Un compte existe déjà avec cet email.": "يوجد حساب بهذا البريد الإلكتروني بالفعل.",
  "Un compte société doit indiquer son numéro ICE à 15 chiffres.": "يجب على حساب الشركة إدخال رقم ICE المكوّن من 15 رقمًا.",
  "Un email universitaire en .ac.ma accélère la vérification étudiante.": "البريد الجامعي المنتهي بـ ‎.ac.ma يسرّع التحقق من صفة الطالب.",
  "Un lit dans une chambre commune": "سرير في غرفة مشتركة",
  "Un numéro ICE compte exactement 15 chiffres.": "رقم ICE يتكوّن من 15 رقمًا بالضبط.",
  "Un paiement est nécessaire pour continuer.": "يلزم الدفع للمتابعة.",
  "Un prix et une durée minimale pour chaque type de location choisi à l’étape précédente.": "سعر ومدة دنيا لكل نوع إيجار اخترته في الخطوة السابقة.",
  "Un RIB marocain compte exactement 24 chiffres.": "يتكوّن الـRIB المغربي من 24 رقمًا بالضبط.",
  "Un séjour à la nuit demande une date de départ.": "الإقامة بالليلة تحتاج إلى تاريخ مغادرة.",
  "Un séjour compte au moins une nuit.": "يجب أن تكون الإقامة ليلة واحدة على الأقل.",
  "Un selfie rapide pour confirmer que c’est bien vous": "صورة شخصية سريعة للتأكد من أنك أنت",
  "Un service externe ne répond pas. Réessayez dans un instant.": "خدمة خارجية لا تستجيب. أعد المحاولة بعد لحظة.",
  "Une annonce peut contenir {max} photos au maximum.": "يمكن أن يحتوي الإعلان على {max} صور كحد أقصى.",
  "Une annonce peut contenir {max} vidéos au maximum.": "يمكن أن يحتوي الإعلان على {max} فيديوهات كحد أقصى.",
  "Une annonce supprimée ne peut plus être modifiée.": "لا يمكن تعديل إعلان محذوف.",
  "Une chambre dans un logement partagé": "غرفة في سكن مشترك",
  "Une demande privée n’apparaît pas dans le fil : vous seul la voyez.": "الطلب الخاص لا يظهر في القائمة العامة: وحدك تراه.",
  "Une erreur est survenue": "حدث خطأ",
  "Une vérification est déjà en cours.": "هناك عملية تحقق جارية بالفعل.",
  "Unité": "الوحدة",
  "Université": "الجامعة",
  "Université (optionnel)": "الجامعة (اختياري)",
  "Université Abdelmalek Essaâdi": "جامعة عبد المالك السعدي",
  "Université Cadi Ayyad": "جامعة القاضي عياض",
  "Université Hassan II — ENCG": "جامعة الحسن الثاني — ENCG",
  "Université Ibn Tofaïl": "جامعة ابن طفيل",
  "Université Ibn Zohr": "جامعة ابن زهر",
  "Université Mohammed Premier": "جامعة محمد الأول",
  "Université Mohammed V": "جامعة محمد الخامس",
  "Université Mohammed VI Polytechnique": "جامعة محمد السادس متعددة التخصصات",
  "Université Moulay Ismaïl": "جامعة مولاي إسماعيل",
  "Université Sidi Mohamed Ben Abdellah": "جامعة سيدي محمد بن عبد الله",
  "Utilisateur": "المستخدم",
  "Utilisateur supprimé": "مستخدم محذوف",
  "Utilisateurs": "المستخدمون",
  "Valeur invalide.": "قيمة غير صالحة.",
  "Ven": "جمعة",
  "Vérification": "التحقق",
  "Vérification d’identité": "التحقق من الهوية",
  "Vérification en cours. Notre équipe répond sous 24 à 48 h et vous recevrez une notification.": "التحقق جارٍ. يرد فريقنا خلال 24 إلى 48 ساعة وستتلقى إشعارًا.",
  "Vérification refusée": "تم رفض التحقق",
  "Vérification refusée.": "تم رفض التحقق.",
  "Vérification…": "جارٍ التحقق…",
  "vérifié": "موثّق",
  "Vérifié": "موثّق",
  "Vérifiée": "موثّقة",
  "Vérifier": "تحقق",
  "Vérifier maintenant": "تحقق الآن",
  "Vérifier mon email": "توثيق بريدي الإلكتروني",
  "Vérifier mon identité": "التحقق من هويتي",
  "Vérifier votre identité": "تحقق من هويتك",
  "Vérifiés": "الموثّقون",
  "Vérifiez votre adresse email auprès de Google avant de vous connecter avec.": "تحقّق من بريدك الإلكتروني لدى Google قبل استخدامه لتسجيل الدخول.",
  "Vérifiez votre adresse email avant d’envoyer des messages.": "تحقّق من بريدك الإلكتروني قبل إرسال الرسائل.",
  "Vérifiez votre adresse email avant de réserver.": "تحقّق من بريدك الإلكتروني قبل الحجز.",
  "Vérifiez votre adresse email.": "تحقّق من بريدك الإلكتروني.",
  "Vérifiez votre email": "وثّق بريدك الإلكتروني",
  "Versements sécurisés par RIB": "تحويلات آمنة إلى حسابك البنكي",
  "Vidéo trop lourde : {max} Mo maximum. Filmez plus court ou en 720p.": "الفيديو كبير جدًا: {max} ميغابايت كحد أقصى. صوّر مقطعًا أقصر أو بدقة 720p.",
  "Vidéos": "الفيديوهات",
  "Vidéos (facultatif)": "الفيديوهات (اختياري)",
  "Ville": "المدينة",
  "Villes": "المدن",
  "villes couvertes": "مدينة مشمولة",
  "villes. Aucune chambre n’est encore en ligne — si vous avez une chambre, une colocation ou un logement à louer, vous pouvez être le premier.": "مدن. لا توجد غرف منشورة بعد — إن كانت لديك غرفة أو سكن مشترك أو سكن للإيجار، يمكنك أن تكون الأول.",
  "Virement bancaire": "تحويل بنكي",
  "Visa, Mastercard — débit immédiat sécurisé": "فيزا، ماستركارد — دفع فوري آمن",
  "Visible dans le fil public": "ظاهر في القائمة العامة",
  "Visité": "تمت زيارته",
  "Visité par Bedly": "زاره Bedly",
  "Visitée par Bedly.": "زارتها Bedly.",
  "visiteurs uniques": "زوار فريدون",
  "Voir": "عرض",
  "Voir {count} logements": "عرض {count} مساكن",
  "Voir 1 logement": "عرض سكن واحد",
  "Voir l’annonce": "عرض الإعلان",
  "Voir l’original sur Wikimedia Commons": "شاهد الأصل على ويكيميديا كومنز",
  "Voir la réservation": "عرض الحجز",
  "Voir le tableau de bord": "عرض لوحة التحكم",
  "Voir les inscrits": "عرض المسجلين",
  "Voir tout": "عرض الكل",
  "Vos annonces": "إعلاناتك",
  "Vos coordonnées": "معلوماتك",
  "Vos documents sont envoyés directement au prestataire de vérification. Bedly n’en conserve que la référence et le résultat — jamais l’image.": "تُرسل وثائقك مباشرة إلى مزوّد التحقق. لا يحتفظ Bedly إلا بالمرجع والنتيجة — وليس الصورة أبدًا.",
  "Vos informations": "معلوماتك",
  "Vos prochaines réservations apparaîtront ici.": "ستظهر حجوزاتك القادمة هنا.",
  "vos vidéos ne doivent contenir": "يجب ألا تحتوي فيديوهاتك على",
  "Votre annonce est visible par les étudiants.": "إعلانك مرئي للطلاب.",
  "Votre avis": "تقييمك",
  "Votre avis est enregistré.": "تم حفظ تقييمك.",
  "Votre avis reste masqué jusqu’à ce que l’autre partie réponde, ou 14 jours après la fin du séjour. Personne ne peut lire le vôtre avant d’écrire le sien.": "يبقى تقييمك مخفيًا حتى يرد الطرف الآخر، أو بعد 14 يومًا من انتهاء الإقامة. لا يمكن لأحد قراءة تقييمك قبل كتابة تقييمه.",
  "Votre avis sera publié quand l’autre partie aura répondu, ou après 14 jours.": "سيُنشر تقييمك عندما يرد الطرف الآخر، أو بعد 14 يومًا.",
  "Votre CNIE, passeport ou carte de séjour": "بطاقتك الوطنية أو جواز سفرك أو بطاقة إقامتك",
  "Votre commentaire": "تعليقك",
  "Votre compte n’a pas accès à cette action.": "لا يملك حسابك صلاحية هذا الإجراء.",
  "Votre dépôt est bloqué par Bedly jusqu’au check-in. L’adresse exacte est débloquée.": "تم تأكيد حجزك. أصبح العنوان الدقيق متاحًا الآن.",
  "Votre email est vérifié : vous pouvez réserver, publier et écrire aux hôtes.": "تم التحقق من بريدك الإلكتروني: يمكنك الحجز والنشر ومراسلة المضيفين.",
  "Votre identité doit d’abord être vérifiée.": "يجب التحقق من هويتك أولًا.",
  "Votre identité est déjà vérifiée.": "تم التحقق من هويتك بالفعل.",
  "Votre identité n’est pas encore vérifiée. Vous pouvez réserver, mais la vérification rassure les hôtes et accélère les acceptations.": "لم يتم التحقق من هويتك بعد. يمكنك الحجز، لكن التحقق يطمئن المضيفين ويسرّع القبول.",
  "Votre mot de passe actuel n’est pas correct.": "كلمة المرور الحالية غير صحيحة.",
  "Votre numéro de téléphone n’est jamais affiché. Les échanges passent par la messagerie Bedly.": "لا يُعرض رقم هاتفك أبدًا. تمر المراسلات عبر رسائل Bedly.",
  "Votre prix en entier, en espèces, sans commission": "سعرك كاملًا، نقدًا، بدون عمولة",
  "votre prix, en espèces": "سعرك، نقدًا",
  "Votre profil est anonymisé et vos annonces retirées. Les réservations et avis dont d’autres personnes dépendent sont conservés sans votre nom. Cette action est irréversible.": "سيتم إخفاء هوية ملفك وحذف إعلاناتك. تُحفظ الحجوزات والتقييمات التي يعتمد عليها آخرون دون اسمك. لا يمكن التراجع عن هذا الإجراء.",
  "Votre réservation est confirmée. L’adresse exacte est maintenant visible.": "تم تأكيد حجزك. أصبح العنوان الدقيق ظاهرًا الآن.",
  "Votre session a expiré. Reconnectez-vous.": "انتهت صلاحية جلستك. سجّل الدخول من جديد.",
  "Vous avez déjà 3 demandes actives — mettez-en une en pause d’abord.": "لديك 3 طلبات نشطة بالفعل — أوقف أحدها أولًا.",
  "Vous avez déjà laissé un avis sur ce séjour.": "لقد قيّمت هذه الإقامة بالفعل.",
  "Vous avez une chambre libre ?": "لديك غرفة شاغرة؟",
  "Vous êtes": "أنت",
  "Vous êtes déjà hôte.": "أنت مضيف بالفعل.",
  "Vous n’avez pas répondu à la demande {reference} à temps ; elle a expiré.": "لم ترد على الطلب {reference} في الوقت المناسب؛ لقد انتهت صلاحيته.",
  "Vous ne pouvez pas faire cela.": "لا يمكنك القيام بذلك.",
  "Vous ne pouvez pas réserver votre propre logement.": "لا يمكنك حجز سكنك الخاص.",
  "Vous ne pouvez pas vous écrire à vous-même.": "لا يمكنك مراسلة نفسك.",
  "Vous pourrez laisser un avis une fois le séjour terminé.": "يمكنك ترك تقييم بعد انتهاء الإقامة.",
  "Vous pouvez désactiver ces emails dans Paramètres → Notifications.": "يمكنك إيقاف هذه الرسائل من الإعدادات ← الإشعارات.",
  "Vous recevez, en espèces": "تتلقى، نقدًا",
  "Vous réglez uniquement les frais de service Bedly. Le loyer se paie en espèces à l’hôte, à la remise des clés.": "تدفع رسوم خدمة Bedly فقط عبر الإنترنت. يُدفع الإيجار نقدًا للمضيف عند تسليم المفاتيح.",
  "Vous serez prévenu ici des demandes, réservations et messages.": "ستصلك هنا تنبيهات الطلبات والحجوزات والرسائل.",
  "Vous vous connectez avec Google. Pour ajouter aussi un mot de passe, utilisez « Mot de passe oublié » sur l’écran de connexion : le code arrivera à votre adresse Gmail.": "أنت تسجّل الدخول عبر Google. لإضافة كلمة مرور أيضًا، استخدم «نسيت كلمة المرور؟» في شاشة تسجيل الدخول: سيصل الرمز إلى بريدك على Gmail.",
  "vous@exemple.ma": "you@example.ma",
  "vous@exemple.ma ou 06 12 34 56 78": "you@example.ma أو 06 12 34 56 78",
  "voyageur(s)": "ضيف",
  "Voyageurs": "الضيوف",
  "Voyageurs max": "أقصى عدد للضيوف",
  "Vue carte": "عرض الخريطة",
  "Vue liste": "عرض القائمة",
  "Vues": "المشاهدات",
  "Vues et demandes": "المشاهدات والطلبات",
  "Wafacash / Cash Plus": "وفاكاش / كاش بلوس",
  "WhatsApp": "واتساب",
  "Wi-Fi": "واي فاي",
  "Wi-Fi fibre": "واي فاي بالألياف",
  "العربية": "العربية",
};
